module.exports = __webpack_public_path__ + "img/verification.5f2e9f5b.svg";